import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogTemplateComponent } from '@optsolservices/ngx-confirm-dialog';
import { BaseService } from 'src/app/core/services/base.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';


@Component({
  selector: 'app-pos-invoice-refund-with-money-container',
  templateUrl: './pos-invoice-refund-with-money-container.component.html',
  styleUrls: ['./pos-invoice-refund-with-money-container.component.scss']
})
export class PosInvoiceRefundWithMoneyContainerComponent implements OnInit {
  // invoice = {
  //   invoiceNumber: '',
  //   invoiceAmount: 0,
  //   invoiceBalance: 0,
  //   salesOrderNumber: '',
  //   depositBalance: 0,
  //   customer: '',
  //   accountBalance: 0
  // };
  invoice = null;

  storeId: number;
  containerId: number;
  refundReasonId: number;
  equipmentTypeCode: string;
  formValid: boolean = false;
  formValue: any;
  // approvedByEmail: string = null;
  // approvedByPwd: string = null;

  constructor(
    public dialogRef: MatDialogRef<PosInvoiceRefundWithMoneyContainerComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private helperService: HelperService,
  ) {
    // console.log('data', data)
  }

  ngOnInit() {
    this.baseService.executeCommand<any>('portal_pos_payment_refund_invoice_from_money_equipment_dialog_config', this.data)
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.invoice = response.data.invoiceDetails;
        } else {
          this.dialogRef.close(false);
        }
      });
  }

  paymentChanged(event: {
    storeId: number;
    containerId: number;
    equipmentTypeCode: string;
    formValid: boolean;
    formValue: any;
  }) {
    this.storeId = event.storeId;
    this.containerId = event.containerId;
    this.equipmentTypeCode = event.equipmentTypeCode;
    this.formValid = event.formValid;
    this.formValue = event.formValue;
  }

  refundReasonChanged(event: {
    refundReasonId: number;
  }) {
    this.refundReasonId = event.refundReasonId;
  }

  save() {
    if (this.formValue.amountTendered < this.invoice.invoiceBalance) {
      const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
        width: '450px',
        data: {
          title: 'Overpaying an invoice',
          text: `Refunding more (${(this.formValue.amountTendered).toFixed(2)}) than what's due on the invoice (${(this.invoice.invoiceBalance).toFixed(2)}) is not allowed.`,
          cancelButtonText: 'Ok',
          showConfirmButton: false,
          showCancelButton: true
        }
      });

    } else {
      const payload = {
        salesOrderNumber: this.invoice.salesOrderNumber,
        invoiceNumber: this.invoice.invoiceNumber,
        storeId: this.storeId,
        containerId: this.containerId,
        refundReasonId: this.refundReasonId,
        equipmentTypeCode: this.equipmentTypeCode,
        amountPaid: this.formValue.amountTendered,
        paymentData: this.formValue,
        // approvedByEmail: this.approvedByEmail,
        // approvedByPwd: this.helperService.hash(this.approvedByPwd),
      };

      const dialogData: OiGroupDialogData = {
        title: 'Authorizing Refund',
        function: 'portal_oi_group_payment_invoice_refund_from_money_equipment',
        postBody: payload
      };

      const ref = this.dialog.open(OiGroupProcessDialogComponent, {
        data: dialogData,
        width: '450px'
      });

      ref.afterClosed().subscribe(oiResult => {
        if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.groupProcessedSuccessfully === true) {
          this.dialogRef.close(true);
        }
      });
    }
  }

}
